module.exports = __webpack_public_path__ + "e9f0470680d51b11ce494c07b2ee38da.MP3";